export enum IQuestionStatus {
  Correct = 'correct',
  Incorrect = 'incorrect',
  Attempted = 'attempted',
  NotAttempted = 'not_attempted',
}

export interface IQuestionStatusObject {
  index: number;
  statusInfo: IQuestionStatus;
}

export const SUPPORT_PHONE = '+917042980055';
export const SUPPORT_EMAIL = 'geneo_support@schoolnetindia.com';
export const SUPPORT_EMAIL_VK12 = 'vk12myedge_support@bvmglobal.org';
export const SUPPORT_EMAIL_CRIMSON = 'it@crimsonschools.com';
export const OTP_LENGTH = 5;
